module.exports = __webpack_public_path__ + "static/img/avatar2.12e5cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar2.png
// module id = ciMv
// module chunks = 1